import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
} from "firebase/firestore";
import { database } from "../../lib/cliente";
import { User } from "../../types";
import { StringDecoder } from "string_decoder";

const UserCollection = collection(database, "users");

export class UserServiceClass {
  private static _instance: UserServiceClass;

  static getInstance(): UserServiceClass {
    if (!this._instance) {
      this._instance = new UserServiceClass();
    }

    return this._instance;
  }

  async getUser(data: string): Promise<User | undefined> {
    try {
      const userId = localStorage.getItem("authToken");
      const refDoc = doc(UserCollection, data ? data : userId ? userId : "");
      const user = await getDoc(refDoc);

      return user.data() as User;
    } catch (err) {
      console.log(err);
    }
  }

  async getUsers(): Promise<User[] | undefined> {
    const userQuery = query(UserCollection, orderBy("createdAt", "desc"));
    const users = await getDocs(userQuery);

    return users.docs.map((item) => ({ ...item.data() })) as User[];
  }
}

export const UserService = UserServiceClass.getInstance();
